// Percorso file: src/components/games/Cronometro.jsx
//
// IL CRONOMETRO DELLA PARTITA — cantiere GAMES, fetta G2, PIANO §3
// «Cronometro» e «Due tempi». Componente di PRESENTAZIONE: lo stato
// (`cron`) vive nel padre (GamePreparePage) e qui arrivano solo le
// funzioni da chiamare. Il conto lo fanno le funzioni pure di
// regolePartita.js; qui si disegna il quadrante e si offrono i comandi:
//
//   · Start / Pause / Resume — manuale, del coach;
//   · +1' / +5' — l'avanzamento veloce per simulare (attivo SOLO mentre
//     corre: in pausa nessuno accumula, PIANO §3);
//   · End 1st half → intervallo (cronometro fermo a zero del 2º tempo,
//     formazione conservata) · End match → chiusura.
//
// `adesso` (ms) arriva dal padre, che lo rinfresca una volta al secondo
// mentre il cronometro corre: il quadrante è una FUNZIONE dello stato e
// dell'istante, non un contatore a scatti (regge lo schermo spento).

import React from "react";
import { FaForward, FaPause, FaPlay, FaStop } from "react-icons/fa";
import { quadrante, secondiDelTempo } from "./regolePartita";
import "./GamesMatch.css";

function etichettaTempo(cron) {
  if (cron.finita) return "Full time";
  if (cron.tempo === 1) return "1st half";
  if (!cron.inCorso && cron.accumulato === 0) return "Half time";
  return "2nd half";
}

export default function Cronometro({
  cron,
  adesso,
  onAvvia,
  onPausa,
  onAvanza,
  onChiudiTempo,
  onChiudiPartita
}) {
  const secondi = secondiDelTempo(cron, adesso);
  const maiPartito = !cron.inCorso && secondi === 0;

  let testoAvvio = "Resume";
  if (maiPartito) testoAvvio = cron.tempo === 1 ? "Start 1st half" : "Start 2nd half";

  return (
    <section className="qpsc-games-clock" aria-label="Match clock">
      <span className="qpsc-games-clock__half">{etichettaTempo(cron)}</span>
      <span
        className={
          "qpsc-games-clock__time" + (cron.inCorso ? " qpsc-games-clock__time--running" : "")
        }
        aria-live="off"
      >
        {quadrante(secondi)}
      </span>

      <div className="qpsc-games-clock__controls">
        {cron.inCorso ? (
          <button type="button" className="qpsc-tool-btn" onClick={onPausa}>
            <FaPause />
            Pause
          </button>
        ) : (
          <button
            type="button"
            className="qpsc-tool-btn"
            onClick={onAvvia}
            disabled={cron.finita}
          >
            <FaPlay />
            {testoAvvio}
          </button>
        )}

        {/* L'avanzamento veloce: due passi, attivi solo mentre corre. */}
        <button
          type="button"
          className="qpsc-ghost-btn"
          onClick={() => onAvanza(60)}
          disabled={!cron.inCorso}
          aria-label="Skip forward one minute"
        >
          <FaForward />
          +1&prime;
        </button>
        <button
          type="button"
          className="qpsc-ghost-btn"
          onClick={() => onAvanza(300)}
          disabled={!cron.inCorso}
          aria-label="Skip forward five minutes"
        >
          <FaForward />
          +5&prime;
        </button>
      </div>

      <div className="qpsc-games-clock__controls">
        {cron.tempo === 1 ? (
          <button type="button" className="qpsc-ghost-btn" onClick={onChiudiTempo}>
            <FaStop />
            End 1st half
          </button>
        ) : (
          <button
            type="button"
            className="qpsc-ghost-btn"
            onClick={onChiudiPartita}
            disabled={cron.finita}
          >
            <FaStop />
            End match
          </button>
        )}
      </div>
    </section>
  );
}
